<template>
<div class="container containerSingleFunction">
  <div class ="row cancel cancelTop">
      <a v-on:click="goOrders" class="modal__close cancel"><span class="screen-reader-text">Cancel</span></a>
  </div>
  <div class="singleFunctionContent uploadSection">
    <header>
      <h2>{{header}}</h2>
       <p class="importOrdersText" v-html="bodyContent"></p>
    </header>
    <div class="row singleFunctionContentFooter">
            <button class="btn-link" v-on:click="goOrders">{{no}}</button>
          <button class="btn-success btn" v-on:click="confirm">{{yes}}</button>
    </div>
  </div>
</div>
</template>

<script>
import { OrdersEnum } from '../../enums/modules/routes'
export default {
  name: 'Confirmation',
  props: ['bodyContent', 'header', 'callback', 'yes', 'no', 'routeBackProp'],
  methods: {
    goOrders: function () {
      this.$router.push({ name: OrdersEnum.Orders })
    },
    cancel: function () {
      this.goOrder()
    },
    confirm: async function () {
      this.callback()
      this.goOrders()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/shipbob-custom/components/orders/_confirm-move.scss';
</style>